module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }), _vm._v(" "), _c('h1', [_vm._v("Munkaidő nyilvántartás")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "groups",
      "label": "Csoport",
      "name": "groups",
      "options": _vm.search.groups.items
    },
    on: {
      "input": _vm.groupChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "workers",
      "label": "Dolgozó",
      "name": "workers",
      "options": _vm.search.workers.items,
      "value": _vm.search.workers.selected
    },
    on: {
      "input": _vm.workerChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "years",
      "label": "Év",
      "name": "years",
      "options": _vm.search.years.items,
      "value": _vm.curr_year
    },
    on: {
      "input": _vm.yearChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "months",
      "label": "Hónap",
      "name": "months",
      "options": _vm.search.months.items,
      "value": _vm.curr_month
    },
    on: {
      "input": _vm.monthChange
    }
  })], 1)]), _vm._v(" "), (_vm.query.worker && _vm.query.worker != '0') ? _c('div', {
    staticClass: "table-with-title"
  }, [_c('h2', [_vm._v("Jelenlét")]), _vm._v(" "), _c('table', {
    staticClass: "list"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.days), function(day, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(day.first_enter ? _vm.trimDate(day.first_enter) : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(day.last_leave ? _vm.trimDate(day.last_leave) : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(day.spent_min))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(day.spent_hour))]), _vm._v(" "), _c('td', _vm._l((day.events), function(event, j) {
      return _c('section', [_c('span', {
        staticStyle: {
          "color": "green"
        }
      }, [_vm._v("BE:")]), _vm._v(" " + _vm._s(_vm.trimDate(event.enter)) + " | "), _c('span', {
        staticStyle: {
          "color": "red"
        }
      }, [_vm._v("KI:")]), _vm._v(" " + _vm._s(event.leave ? _vm.trimDate(event.leave) : '-')), _c('br')])
    }), 0)])
  }), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.month.spent_min))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.month.spent_hour))])])])], 2)])]) : _vm._e()])])], 1), _vm._v(" "), _c('HTMLFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_vm._v("Kereső")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nap")]), _vm._v(" "), _c('th', [_vm._v("Érkezés")]), _vm._v(" "), _c('th', [_vm._v("Távozás")]), _vm._v(" "), _c('th', [_vm._v("Bent töltött percek száma")]), _vm._v(" "), _c('th', [_vm._v("Bent töltött órák száma")]), _vm._v(" "), _c('th', [_vm._v("Mozgások")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Összesen:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbea8aac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/worktime.vue
// module id = 334
// module chunks = 0